/* global $ */
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'
import './swiper.css'

function init () {
  $(document).ready(function () {

    // filter slider
    const swiperElem = $('.filter-slider .swiper-container')
    if (swiperElem.length === 0) {
      return
    }

    let loopVal = false
    let slidesPerView = 5
    if ($(swiperElem).find('.swiper-slide').length > 8) {
      // loop only if swiper has more than 1 slide
      loopVal = true
      slidesPerView = 9
    } else {
      slidesPerView = $(swiperElem).find('.swiper-slide').length
    }
    
    const swiper = new Swiper(swiperElem[0], {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      loop: loopVal,
      watchOverflow: true,
      slidesPerView: 2,
      spaceBetween: 15,
      freeMode: false,
      preventClicks: false,
      preventClicksPropagation: false,
      a11y: false,
      autoHeight: false,
      navigation: {
        nextEl: $('.filter-slider .swiper-button-next')[0],
        prevEl: $('.filter-slider .swiper-button-prev')[0]
      },
      breakpoints: {
        // window width is >= 1001
        1001: {
          slidesPerView: slidesPerView
        },
        600: {
          slidesPerView: 3
        }
      }
    })
    swiper.init()

    // products slider
    const swiperProductsElem = $('.woocommerce-grouped-product-list .swiper-container')
    if(swiperProductsElem.length === 0) {
      return
    }
    let loopVal2 = false
    if($(swiperProductsElem).find('.swiper-slide').length > 4) {
      loopVal2 = true
    } else {
      $(swiperProductsElem).find('.swiper-wrapper').addClass('center')
    }

    const swiperProducts = new Swiper(swiperProductsElem[0], {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      freeMode: false,
      preventClicks: false,
      preventClicksPropagation: false,
      a11y: false,
      autoHeight: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: $('.woocommerce-grouped-product-list .swiper-button-next')[0],
        prevEl: $('.woocommerce-grouped-product-list .swiper-button-prev')[0]
      },
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: 0,
      breakpoints: {
        // window width is >= 1001
        1001: {
          slidesPerView: 5,
          slidesPerGroup: 5,
          spaceBetween: 15
        },
        600: {
          slidesPerView: 2,
          slidesPerGroup: 2,
          spaceBetween: 15
        }
      }
    })
    swiperProducts.init()

  })
}

export default {
  init
}
